import React from 'react';
import LegalLayout from '../components/LegalLayout';

const ShippingDelivery = () => {
  return (
    <LegalLayout title="Shipping & Delivery Policy">
      <p>
        Intlrr primarily delivers services digitally.
      </p>

      <h3>1. Digital Delivery</h3>
      <p>
        Course access, recordings, resources, and certificates are delivered via email, dashboard access, or shared platforms.
      </p>

      <h3>2. Delivery Timeline</h3>
      <p>
        Access details are typically shared within 24 hours of successful enrollment unless otherwise communicated.
      </p>

      <h3>3. Physical Materials</h3>
      <p>
        Currently, Intlrr does not ship any physical products.
      </p>

      <h3>4. Issues</h3>
      <p>
        If you do not receive access, contact <strong>support@intlrr.com</strong>.
      </p>
    </LegalLayout>
  );
};

export default ShippingDelivery;
